import User from '../models/user/User';
import { isVoicifyUser } from './userAccess';

const INTERNAL_TAG_PREFIXES = ['VFY_', 'VOICIFY_'];

export const isInternalVoicifyTag = (tag?: string | null): boolean => {
    const normalizedTag = (tag || '').toUpperCase();
    return INTERNAL_TAG_PREFIXES.some(prefix => normalizedTag.startsWith(prefix));
};

export const canViewInternalVoicifyTags = (currentUser?: User | null): boolean => (
    isVoicifyUser(currentUser)
);

export const filterInternalVoicifyTags = (
    tags: string[],
    showInternalTags: boolean = canViewInternalVoicifyTags()
): string[] => showInternalTags
    ? tags
    : tags.filter(tag => !isInternalVoicifyTag(tag));
